import type { KeyboardEvent } from 'react'

export const onEnterInclusive = (
  e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLFormElement>,
  callback: () => void,
) => {
  if (e.key === 'Enter') {
    if (e.nativeEvent.isComposing) return
    callback()
  }
}

export const metaEnterSubmission = (e: KeyboardEvent, callback: () => void) => {
  if (e.key === 'Enter' && e.metaKey) {
    e.preventDefault()
    callback()
  }
}
